import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./DialNTrade.css";
import DialBanner from "../../Images/dial-banner.png";
import DialData from "../../Images/dial-data.png";
import TrackApi from "../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";

function DialNTrade() {
    const [cookies, setCookie] = useCookies(['LeadId']);

  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your Dial N Trade Note",
      "mx_Custom_1": "Dial N Trade",
      "mx_Custom_2": "Your  Dial N Trade page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  })
    return(
        <>
            <section className="dial-banner-sc">
               <Container>
                    <Row className="align-items-center">
                        <Col xl={6} md={6} sm={6} xs={7}>
                            <div className="banner-left-pnl">
                                <h2>Dial-N-Trade</h2>
                                <ul>
                                    <li>Pan-India accessibility</li>
                                    <li>Secure infrastructure</li>
                                    <li>3-step order placement</li>
                                    <li>No limit on calls for trading</li>
                                </ul>
                            </div>
                        </Col>
                        <Col xl={6} md={6} sm={6} xs={5}>
                            <div className="banner-right-pnl">
                            <img src={DialBanner} alt={DialBanner} className="img-fluid mx-auto d-block" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="dial-data-sc">
               <Container>
                    <Row className="align-items-center">
                        <Col xl={6} md={6} sm={12} xs={12}>
                            <div className="data-right-pnl">
                            <img src={DialData} alt={DialData} className="img-fluid mx-auto d-block" />
                            </div>
                        </Col>
                        <Col xl={6} md={6} sm={12} xs={12}>
                            <div className="data-left-pnl">
                                <h2>Why Use Dial-N-Trade</h2>
                                <p>
                                Dial-N-Trade is useful when you are travelling or in a hurry and cannot access our platforms but do not want to lose out on a trading opportunity. At that point, you may simply call us and place your order over the phone in 3 easy steps!    
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="dial-contact-sc">
               <Container>
                    <Row>
                        <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                            <div className="contact-common-pnl contact-left-pnl">
                                <h2>Timings</h2>
                                <ul>
                                    <li>Equities & Derivatives: 8:30 AM to 4:30 PM</li>
                                    <li>Currency: 9 AM to 5 PM</li>
                                    <li>Commodity: 9 AM till market close</li>
                                </ul>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                            <div className="contact-common-pnl contact-center-pnl">
                                <h2>Contact</h2>
                                <p>9638236000</p>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                            <div className="contact-common-pnl contact-right-pnl">
                                <h2>3 Steps Only</h2>
                                <ul>
                                    <li>Dial 9638236000</li>
                                    <li>Enter IVR Login ID & IVR TPIN (sent via SMS/email during account opening)</li>
                                    <li>Select segment</li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
               </Container>
            </section>   
        </>
    )
}

export default DialNTrade;